import { useState } from 'react';
import { PermissionGuard } from '@/features/auth';
import { Pagination, SearchBar, ButtonLink } from '@/shared/components';
import { useAddOnsQuery } from '../hooks/useAddOnsQuery';
import { useAddOnMutations } from '../hooks/useAddOnMutations';
import { AddOnDataTable } from '../components/AddOnDataTable';

export function AddOnList() {
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [search, setSearch] = useState('');

    const query = useAddOnsQuery({ page, per_page: perPage, search: search || undefined });
    const addons = query.data?.data ?? [];
    const meta = query.data?.meta;

    const { retireMutation } = useAddOnMutations();

    return (
        <section className="space-y-4">
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-semibold">Optional Extras</h1>
                <PermissionGuard permission={{ resource: 'smr', action: 'addon.add' }}>
                    <ButtonLink to="/smr-admin/addons/new" size="sm">New Optional Extra</ButtonLink>
                </PermissionGuard>
            </div>

            <SearchBar searchTerm={search} setSearchTerm={setSearch} placeholder="Search optional extras..." />

            <div className="space-y-4">
                <AddOnDataTable
                    data={addons}
                    isLoading={query.isLoading}
                    onRetire={(id) => retireMutation.mutate(id)}
                />

                {meta && meta.last_page > 1 && (
                    <Pagination
                        currentPage={meta.current_page}
                        lastPage={meta.last_page}
                        total={meta.total}
                        perPage={meta.per_page}
                        from={meta.from}
                        to={meta.to}
                        onPageChange={setPage}
                        onPerPageChange={(n) => { setPerPage(n); setPage(1); }}
                    />
                )}
            </div>
        </section>
    );
}
